import React, { memo, useEffect } from 'react';
import { authActions } from '../';
import { accountActions } from '../../../ModuleAccount';
import { useFirebase } from '@web/firebase';
export var FBConnector = memo(function (_a) {
    var dispatch = _a.dispatch, dispatchAccount = _a.dispatchAccount;
    var instance = useFirebase().instance;
    useEffect(function () {
        if (instance) {
            var unsubscribe_1 = instance.auth.onAuthStateChanged(function (user) {
                console.log('%c SUBSCRIBE TO AUTH CHANGE ', 'background: #B34E14; color: white;');
                dispatchAccount({ type: accountActions.FETCH });
                dispatch({ type: authActions.SUCCESS, user: user });
            });
            return function () {
                console.log('%c UNSUBSCRIBE FROM AUTH CHANGE ', 'background: #B34E14; color: white;');
                unsubscribe_1();
            };
        }
    }, [instance, dispatch, dispatchAccount]);
    return (React.createElement(React.Fragment, null));
});
